import { render, staticRenderFns } from "./Level.vue?vue&type=template&id=5d0ebb0d&"
import script from "./Level.vue?vue&type=script&setup=true&lang=js&"
export * from "./Level.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Level.vue?vue&type=style&index=0&id=5d0ebb0d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports